// src/private/deckKanban.js
// Pure geometry helpers for the deck pile and the kanban brainstorming board.
import { ZONE_BASE_POSITIONS, KANBAN_TOP, KANBAN_STEP, COLUMN_W } from "./dtZones";

// Face-down pile: cards stack at the deck's top-left (90,150); the 0.5px/card
// offset gives a slight layered look without spreading the pile apart.
export function pilePosition(index) {
  return { x: 90 + index * 0.5, y: 150 + index * 0.5 };
}

// True if a flow point falls inside a column's hit-region. COLUMN_W (360) is the
// snap hit-range; the lower y-bound catches drops landing just above the header.
function inColumn(pos, base) {
  return pos.x >= base.x - 40 && pos.x < base.x + COLUMN_W && pos.y >= KANBAN_TOP - 120;
}

// Which phase column (key) contains a point, or null if none.
// Object.entries preserves insertion order for these string keys.
export function columnOf(pos) {
  const hit = Object.entries(ZONE_BASE_POSITIONS).find(([, b]) => inColumn(pos, b));
  return hit ? hit[0] : null;
}

// The slot position for the Nth card (0-based) in a given column.
export function kanbanSlot(columnKey, count) {
  const b = ZONE_BASE_POSITIONS[columnKey];
  return { x: b.x, y: KANBAN_TOP + count * KANBAN_STEP };
}

// Snap a dropped card to the bottom of the list in whatever column it landed in.
// Returns the snapped {x,y}, or null if it wasn't dropped inside a column.
export function snapToKanban(pos, nodes, draggedId) {
  const key = columnOf(pos);
  if (!key) return null;
  const base = ZONE_BASE_POSITIONS[key];
  const count = nodes.filter(
    (n) => n.type === "customCardNode" && n.id !== draggedId && inColumn(n.position, base)
  ).length;
  return kanbanSlot(key, count);
}
